import Character from './character';

export default class Enemy extends Character {

};
